import { render, staticRenderFns } from "./product-group.vue?vue&type=template&id=390f1f76&scoped=true&"
import script from "./product-group.vue?vue&type=script&lang=js&"
export * from "./product-group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390f1f76",
  null
  
)

export default component.exports